export default {
  PASSWORD_PROTECTED_PAGES: 'passwordProtectedPages',
  FORM_ATTACHMENTS: 'formAttachments',
};
